import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getSubQuotationsPostulation } from "../../../../store/actions";
import SubQuotationsPostulationsItem from "./SubQuotationsPostulationsItem";
import styles from "./SubQuotationPostulation.module.scss";

const SubQuotationPostulation = ({
  id,
  getSubQuotationsPostulation,
  subQuotationsPostulations,
  userQuotations,
}) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getSubQuotationsPostulation(id)
  }, [id]);

setTimeout(() => {
  setIsLoading(false)
}, 2000);

  const subQuotationsContent = isLoading ? (
    <div className={styles.loadingState}>Cargando cotizaciones recibidas...</div>
  ) : subQuotationsPostulations.length === 0 ? (
    <div className={styles.emptyState}>Aún no tienes cotizaciones recibidas</div>
  ) : (
    subQuotationsPostulations.map((sub) => (
      <SubQuotationsPostulationsItem
        key={sub.id}
        user={sub.user}
        file={sub.file}
        sub={sub}
      />
    ))
  );

  return (
    <div className={styles.subQuotationsContainer}>    
      <h4  className={styles.subQuotationsContainer_title}>Cotizaciones recibidas:</h4>
      {subQuotationsContent}
    </div>
  );
};

const mapStateToProps = (state) => {

  return {
    subQuotationsPostulations: state.profile.subQuotationsPostulations,
    userQuotations: state.profile.viewQuotations,
  };
};

export default connect(mapStateToProps, { getSubQuotationsPostulation })(
  SubQuotationPostulation
);